import { COUPON_FETCH } from "../actions/types"

export default function(state = {}, action) {
    switch (action.type) {
        case COUPON_FETCH:
            return action.payload
        default:
            return state
    }
}